import script from "./PhoneNumberQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhoneNumberQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./PhoneNumberQuestion.vue?vue&type=style&index=0&id=128035f0&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128035f0"]])

export default __exports__